function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var FAQ = function FAQ(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M22 1a1 1 0 0 1 1 1v15.254a1 1 0 0 1-1 1H7.253l-4.501 5.131a1 1 0 0 1-1.105.276A1 1 0 0 1 1 22.726V2a1 1 0 0 1 1-1zm-1 2H3v17.069l3.048-3.474a1 1 0 0 1 .752-.341H21zm-9.11 10.1a1.005 1.005 0 1 1 .001 2.01 1.005 1.005 0 0 1 0-2.01m.878-8.882c1.104.247 1.95.964 2.32 1.966.372 1.013.193 2.154-.482 3.053-.28.373-.653.696-1.014 1.008-.184.159-.365.313-.507.461-.127.131-.195.304-.195.836a1 1 0 1 1-2 0c0-.712.09-1.532.753-2.223.181-.187.407-.385.641-.588.281-.242.571-.493.722-.694.266-.354.342-.788.204-1.161-.132-.358-.444-.609-.88-.707-.623-.14-1.459.192-1.648.845a1 1 0 1 1-1.921-.555c.47-1.627 2.264-2.633 4.007-2.241"
  }));
};
export default FAQ;